import PjaxBase from 'pjax'
import {Signal} from 'typed-signals'

type Params = {
  fetchDelay: number;
  selector: string;
};

export type PjaxSignalType = 'fetch' | 'ready';

export class Pjax {
  static singleton: Pjax;
  static FETCH = 'fetch';
  static CONTENT = 'content';
  static READY = 'ready';
  static LOAD = 'load';
  private _pjax: PjaxBase | null = null;
  public onChange = new Signal<
    (args: {type: PjaxSignalType; event: Event}) => void
  >();
  private selector = '';

  static create() {
    if (Pjax.singleton) {
      return Pjax.singleton;
    }
    return (Pjax.singleton = new Pjax());
  }

  constructor() {
    this._setup();
  }

  _setup() {
    // https://github.com/MoOx/pjax
    document.addEventListener('pjax:send', (event) => {
      this.onChange.emit({event, type: 'fetch'});
    });
    document.addEventListener('pjax:complete', (event) => {
      this.onChange.emit({event, type: 'ready'});
    });
  }

  getContainer(): HTMLElement | null {
    return document.querySelector(this.selector);
  }

  start({fetchDelay, selector}: Params): void {
    this.selector = selector;
    this._pjax = new PjaxBase({
      cacheBust: false,
      debug: false,
      // @ts-ignore
      delay: fetchDelay, // FIXME: node_modules/pjax/index.js 独自コード
      elements: 'a:not([target="_blank"]):not([href="javascript:void(0)"])',
      // selectors: ['head', '.o-nav', this.selector],
      selectors: ['head', this.selector],
      switches: {
        analytics: () => {
          // TODO: 必要か確認
          // if (window.ga_tracking_id) {
          //   window.gtag('config', window.ga_tracking_id, {
          //     page_path: location.pathname,
          //     page_title: document.title,
          //   })
          // }
        },
        head: function (oldel, newel) {
          const scripts = [...oldel.querySelectorAll('script')];
          scripts.map((s) => {
            oldel.removeChild(s);
          });

          const map = [
            'title',
            'meta[name="description"]',
            'meta[name="keywords"]',
            'meta[property="og:title"]',
            'meta[property="og:type"]',
            'meta[property="og:url"]',
            'meta[property="og:image"]',
            'meta[property="og:site_name"]',
            'meta[name="twitter:card"]',
            'meta[name="twitter:title"]',
            'meta[name="twitter:image"]',
            'meta[itemprop]',
            'link[itemprop]',
            'link[rel="prev"]',
            'link[rel="next"]',
            'link[rel="canonical"]',
            'link[rel="alternate"]',
          ].reverse(); // prependするので

          map.map((k) => {
            const o = oldel.querySelector(k);
            const n = newel.querySelector(k);
            o && oldel.removeChild(o);
            // ieはprependが対応してないfuck
            // n && oldel.prepend(n)
            n && oldel.appendChild(n);
          });
          // @ts-ignore
          this.onSwitch(); // pjaxで必要らしい
        },
      },
      timeout: 0,
    });
  }

  refresh(el?: Element) {
    this._pjax?.refresh(el as any)
  }

  loadUrl(url: string) {
    this._pjax?.loadUrl(url, {
      ...this._pjax.options,
      ...{requestOptions: {}},
    });
  }
}
